{
    "warning": "चेतावणी!",
    "message": "तुम्हाला समजत नसेल असा कोड प्रविष्ट किंवा पेस्ट करू नका.\nहा कंसोल वापरण्याने आक्रमणकर्त्यांना Self-XSS नावाचा आक्रमण वापरून तुमची तोतयागिरी करण्याची आणि तुमची माहिती चोरण्याची अनुमती मिळू शकते."
}
